import React from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'ubs-icons';
import { COLOR } from '../common/constant';

export const getShortcutLabel = (key = 'K') => {
    const platform = typeof navigator === 'undefined'
        ? ''
        : (navigator?.userAgentData?.platform || navigator?.platform || navigator?.userAgent || '');
    return `${/mac|iphone|ipad|ipod/i.test(platform) ? '\u2318' : 'Ctrl'} ${key.toUpperCase()}`;
};

const UCommandPaletteTrigger = (props) => {
    const { placeholder, onClick, className, showShortcut, shortcutKey, shortcut } = props;
    const label = shortcut ?? getShortcutLabel(shortcutKey);

    return (
        <button
            type="button"
            className={`u_cmdp-trigger ${className || ''}`}
            onClick={onClick}
            aria-label={placeholder}
            aria-keyshortcuts={showShortcut ? label : undefined}
        >
            <span className="u_cmdp-trigger-icon"><Icon.Search size={14} fill={COLOR?.u_icon_bg} /></span>
            <span className="u_cmdp-trigger-text">{placeholder}</span>
            {showShortcut && <span className="u_cmdp-kbd u_cmdp-trigger-kbd">{label}</span>}
        </button>
    );
};

UCommandPaletteTrigger.propTypes = {
    placeholder: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    showShortcut: PropTypes.bool,
    shortcutKey: PropTypes.string,
    shortcut: PropTypes.string,
};

UCommandPaletteTrigger.defaultProps = {
    placeholder: 'Search...',
    className: '',
    showShortcut: true,
    shortcutKey: 'K',
    shortcut: undefined,
};

export default UCommandPaletteTrigger;
